export const BulkChargesData = [
    {
        c1title:'Single GL Account Template',
        c1BoldTitle:'Best when all charges and credits are:',
        c1listItem1:'- For current tenants/homeowners',
        c1listItem2:'- Against the same GL Account',
        c1listItem3:'',
        c2Title:'Your template will contain unique unit IDs based on your property selections.'
    },
    {
        c1title:'Multiple GL Accounts Template',
        c1BoldTitle:'Best when charges and credits are:',
        c1listItem1:'- Also for previous tenants/homeowners',
        c1listItem2:'- Against different GL Accounts',
        c1listItem3:'- For different charge/credit dates',
        c2Title:'Your template will contain unique Occupancy IDs based on your property selections.'
    },
]

export const propertyData = [
    'test1 - 912 n creek dr  edmond, OK 73034',
    'test2 - 912 n creek dr  edmond, OK 73034 - $0.00',
    'test3 - 1800 canyon park circle  edmond, OK 73013',
    'test4 - 912 n creek dr  edmond, OK 73034 - $0.00',
    'test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00',
  ]